<template>
    <div id="change-password-page">
        <page-container>
            <div class="container-fluid py-3">
                <div class="row">
                    <div class="col-12">
                        <h1 class="page-title">Change Password</h1>
                    </div>
                </div>
                <div style="max-width: 400px">
                    <qw-input class="form-field mb-3"
                              name="currentPassword"
                              icon="fas fa-unlock"
                              placeholder="Current Password"
                              autocomplete="off"
                              :endIcon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
                              @buttonClick="show = !show"
                              :type="show ? 'text' : 'password'"
                              v-model="currentPassword"/>
                    <set-password :buttonName="this.translations.changePasswordPage.button"
                                  passwordThemeColor="grey-li"
                                  @submit="changePassword" :status="status"></set-password>
                </div>
            </div>
        </page-container>
    </div>
</template>

<script>
    import QwInput from "@/components/global/form/QWInput";
    import SetPassword from "../components/SetPassword";
    import UserService from "../services/UserService";

    export default {
        name: "change-password-page",
        components: {
            QwInput,
            SetPassword
        },
        data() {
            return {
                errors: [],
                status: "ready",
                currentPassword: '',
                show: false,
                multiLine: true,
                snackbar: false,
                text: 'I\'m a multi-line snackbar.',
            }
        },
        methods: {
            async changePassword(password) {
                this.errors = [];
                if (this.currentPassword === null || this.currentPassword === '') {
                    this.$store.commit("setToastMessage", {
                        title: 'Current Password is missing!',
                        type: 'warning', hideIcon: false
                    });
                    return;
                }
                this.status = "loading";
                try {
                    UserService.changePassword(this.currentPassword, password)
                        .then(() => {
                            this.$store.commit("setToastMessage", {
                                title: 'Change Password Successful!',
                                type: 'success', hideIcon: false
                            });
                        })
                        .catch(() => {
                            this.$store.commit("setToastMessage", {
                                title: 'Change Password Failed',
                                description: 'Make sure you provided the correct current password!',
                                type: 'error', hideIcon: false
                            });
                        });
                } catch (e) {
                    console.log(e);
                } finally {
                    this.status = "ready";
                }
            },
        },
        computed: {
            hasErrors() {
                return !!(this.errors && this.errors.length);
            }
        }
    }
</script>
<style lang="scss" scoped>
    #change-password-page {
        .page-title {
            font-family: "Lato", sans-serif;
            font-size: 22px;
            font-weight: 700;
            margin: 0px 0px 30px 0px;
        }
    }
</style>
